import { formatGiftBalance } from './horasRegalo/giftBalance';
import React from 'react';
import { Briefcase, CheckCircle2, Clock3, Gift } from 'lucide-react';
import { Afiliacion } from '../services/afiliadosService';

const pasos: { label: string; campo: keyof Afiliacion }[] = [
    {label: 'Envío de contrato', campo: 'paso1_contrato_enviado'},
    {label: 'Recepción de contrato firmado', campo: 'paso2_contrato_firmado'},
    {label: 'Envío de documentación fiscal', campo: 'paso3_docs_fiscales_enviados'},
    {label: 'Recepción de requisitos de la empresa', campo: 'paso4_requisitos_recibidos'},
    {label: 'Registro y exhibición del NIT', campo: 'paso5_nit_exhibido'},
    {label: 'Kardex de correspondencia', campo: 'paso6_kardex_recepcion_abierto'},
    {label: 'Kardex de horas de regalo', campo: 'paso7_kardex_horas_abierto'},
];

export default function OficinaVirtualDetalle({ expediente }: {expediente: Afiliacion}) {
    const completados = pasos.filter(p => expediente[p.campo]).length;
    return <section className="rounded-2xl border border-[#61257b]/15 bg-white overflow-hidden" aria-label="Expediente de oficina virtual">
        <div className="p-5 bg-gradient-to-r from-[#61257b]/10 to-[#c1348b]/5">
            <div className="flex items-center gap-3">
                <Briefcase className="w-6 h-6 text-[#61257b]" />
                <div className="flex-1"><h2 className="font-bold text-[#61257b]">Oficina virtual</h2><p className="text-sm text-slate-600">{expediente.empresa_nombre}</p></div>
                <span className="text-xs font-bold rounded-full bg-white px-3 py-2 text-[#61257b]">{completados}/7 pasos</span>
            </div>
            <div className="mt-4 h-2 rounded-full bg-white" role="progressbar" aria-valuemin={0} aria-valuemax={7} aria-valuenow={completados} aria-label="Pasos completados">
                <div className="h-full rounded-full bg-[#c1348b] transition-all" style={{width: `${completados / 7 * 100}%`}} />
            </div>
        </div>
        {!expediente.formulario_habilitado && <p className="mx-5 mt-4 text-sm text-[#61257b]">Reserva finalizada · Beneficios no disponibles</p>}
        <ol className="p-5 grid gap-2">
            {pasos.map((p, i) => <li key={p.campo} className="flex items-center gap-3 rounded-xl border border-slate-100 p-3">
                <span className="w-7 h-7 shrink-0 flex items-center justify-center rounded-full bg-[#61257b]/10 text-[#61257b] text-xs font-bold">{i + 1}</span>
                <span className="flex-1 text-sm text-slate-700">{p.label}</span>
                <span className={`flex items-center gap-1 text-xs font-semibold ${expediente[p.campo] ? 'text-[#61257b]' : 'text-slate-500'}`}>
                    {expediente[p.campo] ? <CheckCircle2 size={14} /> : <Clock3 size={14} />}
                    {expediente[p.campo] ? 'Completado' : 'Pendiente'}
                </span>
            </li>)}
        </ol>
        <div className="mx-5 mb-5 p-4 rounded-xl bg-[#61257b]/5 flex items-center gap-3 text-[#61257b]">
            <Gift size={22} /><div><p className="text-xs font-semibold">Horas de regalo disponibles</p><p className="text-xl font-bold">{formatGiftBalance(Number(expediente.horas_gratuitas_disponibles ?? 0) * 60)}</p></div>
        </div>
    </section>;
}
